export const CREATE_PHONE_CODE_SIGNIN = 'CREATE_PHONE_CODE_SIGNIN';
export const CREATE_PHONE_CODE_SIGNIN_SUCCESS =
  'CREATE_PHONE_CODE_SIGNIN_SUCCESS';
export const CREATE_PHONE_CODE_SIGNIN_FAILURE =
  'CREATE_PHONE_CODE_SIGNIN_FAILURE';
export const createPhoneCode = phoneNumber => ({
  type: CREATE_PHONE_CODE_SIGNIN,
  payload: {
    phoneNumber,
    accountType: 'customer',
    checkPhoneNumberIsRegistered: true
  }
});

export const CREATE_TOKEN = 'CREATE_TOKEN';
export const CREATE_TOKEN_SUCCESS = 'CREATE_TOKEN_SUCCESS';
export const createToken = data => ({
  type: CREATE_TOKEN,
  payload: {
    ...data,
    loginType: 'phone',
    accountType: 'customer',
    tokenFormat: 'jwt'
  }
});
